import { render, staticRenderFns } from "./vDate.vue?vue&type=template&id=5ebe6dc4"
import script from "./vDate.vue?vue&type=script&lang=js"
export * from "./vDate.vue?vue&type=script&lang=js"
import style0 from "./vDate.vue?vue&type=style&index=0&id=5ebe6dc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports